import { render, staticRenderFns } from "./JdsDraftingTable.vue?vue&type=template&id=05853782&scoped=true&"
import script from "./JdsDraftingTable.vue?vue&type=script&lang=ts&"
export * from "./JdsDraftingTable.vue?vue&type=script&lang=ts&"
import style0 from "./JdsDraftingTable.vue?vue&type=style&index=0&id=05853782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05853782",
  null
  
)

export default component.exports